import type { Movie } from "@/lib/types";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

interface RelatedSectionProps {
  movies: Movie[];
}

export default function RelatedSection({ movies }: RelatedSectionProps) {
  if (movies.length === 0) return null;

  return (
    <section id="related" className="mt-12 md:mt-16 scroll-mt-24">
      <SectionHeading
        eyebrow="More Like This"
        title="推荐影视作品"
        description="根据题材、地区与类型相似度为你挑选，风格接近，适合接着看。"
        linkTo="/category"
        linkLabel="浏览更多作品"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}